import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextSignalHyp = () => {

return(
<div>
    
<Typography variant="h6" >

Variants: rs1801131, rs1799983 -- TSAB0741 heterozygote genotype T/G -- glu429-to-ala substitution  -- Possibly impaired folate metabolism, but no association with hypertension <br /><br />

The gene MTHFR provides instructions for making an enzyme called methylenetetrahydrofolate reductase and has a role in processing amino acids. 
Methylenetetrahydrofolate reductase is important for vitamin folate (also called vitamin B9). It converts a form of folate to a different form of folate. 
Primary form of folate found in blood, and is necessary for the multistep process that converts the amino acid homocysteine to another amino acid, methionine. 
The body uses methionine to make proteins and other important compounds.<br /><br />
OMIM: From studies of the 677C-T mutation in cardiovascular patients and controls, Kluijtmans et al. (1996) concluded that 
homozygosity for this frequent mutation in the MTHFR gene is associated with a 3-fold increase in risk for premature cardiovascular disease<br /><br />

A list of variants in gene GATA4 reported as benign for Congenital heart disease can be found in:  
https://clinvarminer.genetics.utah.edu/variants-by-gene/GATA4/condition/Congenital%20heart%20disease/benign <br /><br />

The variant SNP rs12458 (GATA4) is cited in pharmgkb regarding drug response:<br /><br /> 
within a specific region of GATA4 3′UTR is associated with bleeding complications of warfarin at therapeutic range of INR, 
likely by altering the transcriptional gene regulation CYP2C9.<br /><br />

The variant rs1801253 (ADRB1) is relevant to drug response: average efficacy of the beta blocker metoprolol in lowering blood pressure<br /><br />

 
</Typography>

</div>
)
}